import { adminClient as apolloClient } from '@/store/apollo';

import ReturnReasonsGql from '@/extensions/shop/store/graphql/queries/ReturnReasons.gql';
import SaveReturnReasonGql from '@/extensions/shop/store/graphql/mutations/SaveReturnReason.gql';
import DeleteReturnReasonGql from '@/extensions/shop/store/graphql/mutations/DeleteReturnReason.gql';

export default {
    fetchReturnReasons: shopID =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ReturnReasonsGql,
                    variables: { shop_id: parseInt(shopID) },
                    fetchPolicy: 'network-only',
                })
                .then(({ data }) => resolve(data.CO_ReturnReasons))
                .catch(err => reject(err));
        }),

    save: (returnReason, shopID = null) => {
        if (!returnReason) throw new Error('returnReason argument is missing');

        const payload = _.removeDeepByKey(returnReason, '__typename');
        const variables = { returnReason: payload };
        if (shopID !== null) variables.shop_id = parseInt(shopID);

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveReturnReasonGql,
                    variables,
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveReturnReason);
                })
                .catch(err => reject(err));
        });
    },

    remove: id =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteReturnReasonGql,
                    variables: { id: parseInt(id) },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteReturnReason);
                })
                .catch(err => reject(err));
        }),
};
